/* import __COLOCATED_TEMPLATE__ from './single-page-app.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

interface Args {
  appIdCode: string;
  email: string;
  highlightLanguage: string;
  selectedUserIdentifier: string;
  selectedProgrammingLanguage: string;
  userHash: string;
  userID: string;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class SinglePageApp extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;

  @action
  onCopyCode() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'copy_code_snippet',
      metadata: {
        is_idv: true,
        identifier: this.args.selectedUserIdentifier,
        app_type: 'spa',
        programming_language: this.args.selectedProgrammingLanguage,
      },
      place: 'installation-new',
      section: 'settings',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::Web::IdvSetup::CodeSnippets::UpdateSite::SinglePageApp': typeof SinglePageApp;
    'installation-new/web/idv-setup/code-snippets/update-site/single-page-app': typeof SinglePageApp;
  }
}
